var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.733 0H7.4a.533.533 0 1 1 0 1.067H4.733a2.667 2.667 0 0 0-2.666 2.666v5.334a.533.533 0 1 1-1.067 0V3.733A3.733 3.733 0 0 1 4.733 0zm-3.2 11.2a.533.533 0 0 0-.533.533v.534A3.733 3.733 0 0 0 4.733 16H7.4a.533.533 0 1 0 0-1.067H4.733a2.667 2.667 0 0 1-2.666-2.666v-.534a.533.533 0 0 0-.534-.533zm12.8.533a.533.533 0 0 0-1.066 0v.534a2.667 2.667 0 0 1-2.667 2.666h-.533a.533.533 0 0 0 0 1.067h.533a3.733 3.733 0 0 0 3.734-3.733v-.534zM10.6 1.067h-.533a.533.533 0 0 1 0-1.067h.533a3.733 3.733 0 0 1 3.734 3.733v4a.533.533 0 0 1-1.067 0v-4A2.667 2.667 0 0 0 10.6 1.067zm-6.667 7.2c0-.295.24-.534.534-.534h5.6a.533.533 0 1 1 0 1.067h-5.6a.533.533 0 0 1-.534-.533zm.534-4.8a.533.533 0 1 0 0 1.066H6.6a.533.533 0 1 0 0-1.066H4.467zm-.534 2.666c0-.294.24-.533.534-.533H8.2a.533.533 0 1 1 0 1.067H4.467a.533.533 0 0 1-.534-.534z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineContent);
export default __webpack_public_path__ + "static/media/outline-content.f7b61db2dfd573baff3d55f9f1cf1b62.svg";
export { ForwardRef as ReactComponent };